import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/config/api'
import { axios } from '@/lib/axios'
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query'
import { Dto } from '@/types'

const getServices = (signal?: AbortSignal): Promise<Dto['ServicesAvailabilityDto']> => axios.get('/metadata/services', { signal })

type QueryFnType = typeof getServices

type UseGetServicesOptions = {
  config?: QueryConfig<QueryFnType>
}

export const useGetServices = ({ config }: UseGetServicesOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [QUERY_KEYS.getServices],
    queryFn: ({ signal }) => getServices(signal),
  })
}
